import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const useStyles = makeStyles(() => ({
  btnConfigure: {
    borderColor: colors.brandBlue500,
    color: colors.brandBlue500,
    fontFamily: "Manrope",
    fontSize: 14,
    "&:focus": {
      border: `1px solid ${colors.brandBlue500} !important`,
    },
  },
  btnPeriod: {
    borderColor: colors.gray600,
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: 14,
    "&:focus": {
      border: `1px solid ${colors.gray600} !important`,
    },
  },
  tabPanel: {
    "& .MuiTab-root": {
      color: colors.gray500,
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
    },
    "& .MuiTab-root.Mui-selected": {
      backgroundColor: "unset",
      borderBottom: `2px solid ${colors.brandBlue500} !important`,
      color: colors.brandBlue500,
    },
    "& .MuiTabPanel-root": {
      border: "none",
      padding: 0,
      overflow: "unset",
      width: "calc(100% + 1px)",
    },
  },
}));

export const ContainerNumberLabel = styled("p")(() => ({
  color: colors.gray600,
  cursor: "pointer",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  letterSpacing: "0.4px",
  lineHeight: "16px", //* 133.333% */
  textDecorationLine: "underline",
}));
